<script setup lang="ts">
/** Aventross AGM (Audited) — 원본 합본 문서 7부(PART VIII). gen_vue 로 템플릿 글자 그대로 생성. */
import CddVarField from '../../../aura/agm/cdd/CddVarField.vue';
import DocScope from '../../../aura/agm/cdd/DocScope.vue';
import AgmSigners from '../../../aura/agm/cdd/AgmSigners.vue';
import { useRepeat } from '../useRepeat';
import '../../../aura/agm/docs/agmDoc.css';
import '../avDoc.css';

const R = useRepeat();
void CddVarField; void DocScope; void AgmSigners;
</script>

<template>
  <div class="agm-doc av-doc">
    <p class="doc-p center bold">PART VIII</p>
    <div class="gap" />
    <p class="doc-p center bold">COMPANIES ACT 1967</p>
    <p class="doc-p center bold">Regulation 36</p>
    <p class="doc-p center bold">COMPANIES (FILING OF DOCUMENTS)</p>
    <p class="doc-p center bold">REGULATIONS</p>
    <div class="gap" />
    <p class="doc-p center bold">DECLARATION OF REGISTER OF CONTROLLER(S), </p>
    <p class="doc-p center bold">NOMINEE DIRECTOR(S) AND NOMINEE SHAREHOLDER(S)</p>
    <div class="gap" />
    <p class="doc-p bold">Name of Company: <CddVarField field-key="company_name" label="Company Name" /></p>
    <p class="doc-p bold">Company Registration Number: <CddVarField field-key="company_registration_no" label="Company Registration No." /></p>
    <p class="doc-p bold">Address: <CddVarField field-key="registered_office_address" label="Registered office address" /></p>
    <div class="gap" />
    <p class="doc-p">I, <CddVarField field-key="declaring_director_name" label="Declaring director" />, Passport/NRIC/Identification Number: <CddVarField field-key="declaring_director_id_no" label="NRIC / Passport No." />, being the director of the Company hereby declared and confirmed that the Company: - </p>
    <div class="gap" />
    <p class="doc-p">Has kept the information and particulars in the Register of Controller(s), Register of Nominee Director(s) and Register of Nominee Shareholder(s) up-to-date and correct (refer to the Annex A, Annex B and Annex C);</p>
    <div class="gap" />
    <p class="doc-p">Has kept Register of Controller(s), Register of Nominee Director(s) and Register of Nominee Shareholder(s) in the: - </p>
    <p class="doc-p">*at the company’s registered office;</p>
    <p class="doc-p">*at the registered office of a registered corporate service provider appointed by the company for the purpose of providing a registered office, business address, correspondence or administrative address or other related services for the company;</p>
    <div class="gap" />
    <p class="doc-p">Date: <CddVarField field-key="agm_date" label="AGM date" /></p>
    <div class="gap" />
    <p class="doc-p">__________________________</p>
    <p class="doc-p">Signature</p>
    <p class="doc-p">Name:<CddVarField field-key="declaring_director_name" label="Declaring director" /></p>
    <p class="doc-p">Designation: Director</p>
    <div class="gap" />
  </div>
</template>
